import './App.css';
import Home from './pages';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Sidebar from './components/Sidebar';
// import Navbar from './components/Navbar';
// import About from './pages/about';
// import Gallery from './pages/gallery';
// import Contact from './pages/contact';
// import Press from './pages/press';


import Footer from './components/Footer';
import { useEffect } from 'react';
import styled from 'styled-components';
import preloadList from './preload-list.json';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
flex: 1;
`;

const AppContent = () => {
  const location = useLocation();
  // Hide footer on home page logic can be done here or styling
  // Assuming we want to hide it ONLY on home page
  const isHome = location.pathname === '/';

  // Aggressive Preloading Logic
  useEffect(() => {
    // Small delay to prioritize initial page load
    const timer = setTimeout(() => {
      preloadList.forEach((resource) => {
        if (resource.endsWith('.pdf')) {
          // For PDFs, we use fetch to populate the browser cache
          fetch(resource, { mode: 'no-cors' }).catch(() => { });
        } else {
          // For Images, 'new Image()' is the standard preloading technique
          const img = new Image();
          img.src = resource;
        }
      });
      console.log('Preloading started for ' + preloadList.length + ' assets.');
    }, 2000); // Start 2 seconds after mount

    return () => clearTimeout(timer);
  }, []);

  return (
    <AppContainer>
      <ContentWrapper>
        <Home />
      </ContentWrapper>
      {/* Hide Footer on Home Page Mobile, but user said 'when IT is displayed' (mobile specific). 
          Global footer might be easier to just hide on home page generally if duplicated? 
          User said: 'footer should not display when it is displayed' (referring to the new mobile link).
          Since new link is MOBILE only, we want footer hidden on HOME PAGE on MOBILE.
          We can pass a prop or class to Footer? Or just use CSS?
          Let's verify via CSS first: .home-page .footer { display: none } on mobile.
          But App.js doesn't wrap Home with a class based on route easily without hook.
      */}
      <Footer isHome={isHome} />
    </AppContainer>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
